"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _clsx = _interopRequireDefault(require("clsx"));
var _index = _interopRequireDefault(require("./index.style"));
// eslint-disable-next-line react/display-name
const MenuItem = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    children = '',
    className = '',
    ...others
  } = _ref;
  const classes = (0, _index.default)();
  return /*#__PURE__*/_react.default.createElement(_MenuItem.default, (0, _extends2.default)({}, others, {
    ref: ref,
    className: (0, _clsx.default)(classes.root, className)
  }), children);
});
var _default = exports.default = MenuItem;